import React, { useState, useRef, useEffect } from 'react';
import { IoSearchSharp } from 'react-icons/io5';
import { NavLink, Navigate } from 'react-router-dom';
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
import { searchByHeader } from "../Redux/authAction";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import api from '../config/api';

const Input = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(''); // State variable for input value
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const search = useSelector((state) => state.authReducer.search);

  const [key, setkey] = useState();
  const [categorytitle , setCategorytitle] = useState();


  const keyDown = (event) => {
    
      setkey(event.key)
      if(event.keyCode == 13){
        navigate(`/resumeMaker/temp/${categorytitle}`);
      }
  }



  // Define templateData and assign the provided API response
  const [templateData, setTemplateData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Fetch template data from API
  useEffect(() => {
    fetch(api.getUrl("/aapi/getTempletes.php"))
      .then(response => response.json())
      .then(data => {
        setTemplateData(data);
        setFilteredData(data); // Initially set filtered data to all templates
      })
      .catch(error => console.error('Error fetching template data:', error));
  }, []);

  const handleInput = (event) => {
    event.stopPropagation(); // Stop the event propagation
    if (open && inputValue.trim() !== '') {
      console.log(inputValue); 
      navigate(`/category/search/${inputValue}`)
    }
    setOpen(true);
  };
  

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setOpen(false);
      
    }
  };


  const handleClickonInput = (event) => {
   alert("My Name is ");
    console.log("clicked on the input  ..................................................... ");
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      handleClickOutside(event);
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  // Function to handle input change and filter data accordingly
  const handleInputChange = (event) => {
    const searchText = event.target.value.toLowerCase();
    setCategorytitle(event.target.value)
    setInputValue(event.target.value); // Update input value state
    const filtered = templateData.filter(template => template.title.toLowerCase().includes(searchText));
    setFilteredData(filtered);
  };

  return (
    <>
      <div className={`flex relative px-2 justify-end py-1 ${open ? 'shadow-md' : ''}`}>
        <input
    
          // onKeyDown={handleClickonInput}
          
          onKeyDown={keyDown}
          onSubmit={handleClickonInput}
          ref={inputRef}
          type='text'
          placeholder="Search Templetes ... ."
          className={`h-[25px] focus:outline-0 placeholder:text-[13px] transition-all duration-300 bg-white ${
            open ? 'w-[300px] pl-3 pr-8' : 'w-[0px] pl-3 pr-0'
          }`}
          value={inputValue} // Use inputValue state variable for input value
          onChange={handleInputChange} 
        />
        <div
          className={`transition-all duration-300 h-[25px] w-[25px] absolute top-0 right-0 ${
            open ? 'mr-[300px] ' : ''
          }`}
        >
          <IoSearchSharp className='text-[22px] mt-1 text-[#2b2b2b] cursor-pointer' onClick={(e) => handleInput(e)} />
        </div>
      </div>

      {open && (
        <div
          style={{
            zIndex: 9999,
            background: 'white',
            position: 'absolute',
            top: "50px",
            right: "130px",
            width: "330px",
            maxHeight: "500px", 
            overflowY: "auto" 
          }}
          className="transition-all duration-300 shadow-md"
        >
          {filteredData.map((template, index) => (
            <NavLink onClick={() => {
              dispatch(searchByHeader(true))
            }} to={{ pathname: `/category/search/${template.title}`, state: { templateData: template } }} key={index} className="block w-full">
              <div className='flex p-4 gap-3 items-center'>
                <HiOutlineClipboardDocumentList className='text-[22px]' />
                <p className='font-semibold text-[13px]'>{template.title}</p> {/* Display template name */}
              </div>
            </NavLink>
          ))}
        </div>
      )}
    </>
  );
};

export default Input;
